/* eslint-disable no-plusplus */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useState, useEffect } from 'react';

import {
  Button,
  Conditional,
  Text,
  Space,
  Popup,
  Cross,
} from '@cashfree-intl/coherent';

import { getItemFromLocalStorage } from 'utils/common';
import cloneDeep from 'lodash/cloneDeep';

import {
  CUSTOM,
  DEFAULT,
  DEFAULT_POLICY_LIST,
  EDIT,
  ERROR,
  EXPONENTIAL,
  FIXED,
  SUCCESS,
  TEST,
  TEST_VALUE,
  WEBHOOK,
  SAVE,
} from '../constants';

import {
  formatNotificationList,
  getDisableOption,
  getRetryInterval,
  prepareFormData,
  prepareRemovedEventsData,
  removedEventsData,
  submitButtonDisplay,
} from '../helpers';
import {
  StyledContentWrapper,
  StyledModal,
  StyledModalActions,
  StyledModalContent,
  StyledModalHeader,
} from '../styled';
import ConfigTimeline from './Timeline';
import EndpointDetails from './EndpointDetails';
import PolicyList from './PolicyList';
import Summary from './Summary';

function TransactionWebhookModal({
  open,
  title,
  closeModal,
  getAllNotificationTypes,
  testWebhook,
  handleTransactionFormSubmit,
  actionsMode,
  testWebhookData,
  editEventsList,
  isLoading,
  markAsDone,
}) {
  const [step, setStep] = useState(0);
  const [notificationList, setNotificationList] = useState([]);
  const [checkedItems, setCheckedItems] = useState([[]]);
  const [searchInput, setSearchInput] = useState([]);
  const [filteredData, setFilterData] = useState([[]]);
  const [testStatus, setTestStatus] = useState('');
  const [endpointDetails, setEndpointDetails] = useState({
    channelValue: '',
    cfApiVersion: '',
  });
  const [policyListData, setPolicyListData] = useState([
    DEFAULT_POLICY_LIST[DEFAULT],
  ]);
  const [loading, setLoading] = useState(false);
  const [continueLoading, setContinueLoading] = useState(false);
  const [isEndpointChanging, setEndpointChanging] = useState(!actionsMode);

  // const modalRef = useRef(null);

  const merchantId = getItemFromLocalStorage('merchantId');

  // useClickOutside(modalRef, closeModal);

  useEffect(() => {
    if (actionsMode === EDIT) {
      const eventsObj = cloneDeep(testWebhookData);
      setNotificationList(editEventsList);
      const tempFilterData = [];
      const tempSearch = [];
      eventsObj.policyDetails.forEach(() => {
        tempFilterData.push(editEventsList);
        tempSearch.push('');
      });
      setFilterData(tempFilterData);
      setSearchInput([...tempSearch]);
      setEndpointDetails({ ...eventsObj.channelDetails });
      if (eventsObj.checkedItems.length) {
        setCheckedItems(eventsObj.checkedItems);
      }
      setPolicyListData(eventsObj.policyDetails);
      setStep(0);
    }
    if (actionsMode === TEST) {
      const eventsObj = cloneDeep(testWebhookData);
      setEndpointDetails({ ...eventsObj.channelDetails });
    }
  }, []);

  const handleEndpointHandling = value => {
    setEndpointChanging(value);
  };

  const createNotificationTypesList = list => {
    const formattedList = formatNotificationList(list);
    setNotificationList(formattedList);
    const temp = [formattedList];
    setFilterData([...temp]);
  };

  const removeEvent = (item, index) => {
    const tempCheckedItem = checkedItems;
    const updatedCheckedItems = tempCheckedItem[index].filter(
      val => val !== item,
    );
    tempCheckedItem[index] = updatedCheckedItems;

    setCheckedItems([...tempCheckedItem]);
  };

  const addEvent = (item, index) => {
    checkedItems[index].push(item);
    setCheckedItems([...checkedItems]);
  };

  const onSelectAllHandler = index => {
    const tempCheckedItems = checkedItems;
    tempCheckedItems[index] = filteredData[index].filter(
      fData => !getDisableOption(fData, tempCheckedItems, index),
    );
    setCheckedItems([...tempCheckedItems]);
  };

  const onClearAllHandler = index => {
    const tempCheckedItems = checkedItems;
    tempCheckedItems[index] = [];
    setCheckedItems([...tempCheckedItems]);
  };

  const onTestClickHandler = channelValue => {
    setLoading(true);
    testWebhook({
      data: {
        postData: {
          data: {
            test_object: {
              test_key: TEST_VALUE,
            },
          },
          event_time: new Date().toJSON(),
          type: WEBHOOK,
        },
      },
      uri: channelValue.trim(),
      cb: response => {
        const { statusCode } = response;
        setLoading(false);
        handleEndpointHandling(false);
        if (statusCode >= 200 && statusCode < 300) {
          setTestStatus(SUCCESS);
        } else setTestStatus(ERROR);
        setEndpointDetails(endpointDetails => ({
          ...endpointDetails,
          channelValue,
        }));
      },
      errorCb: () => {
        setLoading(false);
      },
    });
  };

  const handleSubmitClick = () => {
    if (step === 0) {
      if (!(actionsMode === EDIT)) {
        setContinueLoading(true);
        const { cfApiVersion } = endpointDetails;
        getAllNotificationTypes({
          cfApiVersion,
          cb: response => {
            createNotificationTypesList(response.notificationTypes);
            setStep(step + 1);
            setContinueLoading(false);
          },
          errorCb: () => {
            setContinueLoading(false);
          },
        });
      } else if (actionsMode === TEST) {
        closeModal();
      } else if (actionsMode === SAVE) {
        markAsDone();
      }
    }
    if (step === 2) {
      handleTransactionFormSubmit({
        data: prepareFormData(
          endpointDetails,
          policyListData,
          merchantId,
          checkedItems,
        ),
        removedEvents: prepareRemovedEventsData(
          removedEventsData(checkedItems, actionsMode, testWebhookData),
          testWebhookData,
          policyListData,
          actionsMode,
        ),
        mode: actionsMode,
      });
      markAsDone();
    } else {
      setStep(s => s + 1);
      if (actionsMode === SAVE) {
        markAsDone();
      }
    }
  };

  const handleBack = () => {
    setStep(s => s - 1);
  };

  const handlePolicyListChange = (
    obj: { name: string; value: any },
    index: number,
  ) => {
    if (
      obj.name === 'maxRetryAttempts' &&
      policyListData[index].retryType === CUSTOM
    ) {
      const newArr = policyListData[index].retryInterval;
      if (newArr.length > obj.value) {
        const difference = newArr.length - obj.value;
        const index = newArr.length - difference;
        const numberOfElementToDelete = newArr.length - obj.value;
        newArr.splice(index, numberOfElementToDelete);
      } else if (newArr.length < obj.value) {
        let lastIndexVal = newArr[newArr.length - 1];
        const lastIndex = newArr.length;
        for (let i = lastIndex; i < obj.value; i++) {
          const tempValue = lastIndexVal * 2;
          newArr.push(tempValue);
          lastIndexVal = tempValue;
        }
      }

      const tempPolicyListData = policyListData;
      const tempPolicyObj = tempPolicyListData[index];
      const newPolicyObj = {
        ...tempPolicyObj,
        [obj.name]: obj.value,
        retryInterval: newArr,
      };
      tempPolicyListData.splice(index, 1, newPolicyObj);
      setPolicyListData([...tempPolicyListData]);
    } else if (obj.name === 'retryType') {
      const tempPolicyListData = policyListData;
      tempPolicyListData[index] = cloneDeep(DEFAULT_POLICY_LIST[obj.value]);
      setPolicyListData([...tempPolicyListData]);
    } else {
      const tempPolicyListData = policyListData;
      const tempPolicyObj = tempPolicyListData[index];
      let newPolicyObj = { ...tempPolicyObj, [obj.name]: obj.value };
      if (
        newPolicyObj.retryType === FIXED ||
        newPolicyObj.retryType === EXPONENTIAL
      ) {
        const newInterVal = getRetryInterval(newPolicyObj);
        newPolicyObj = { ...newPolicyObj, retryInterval: newInterVal };
      }
      tempPolicyListData.splice(index, 1, newPolicyObj);
      setPolicyListData([...tempPolicyListData]);
    }
  };

  const handlePolicyListDelete = index => {
    const tempPolicyListData = policyListData;
    tempPolicyListData.splice(index, 1);
    const tempCheckedItems = checkedItems;
    tempCheckedItems.splice(index, 1);
    const tempFilteredData = filteredData;
    tempFilteredData.splice(index, 1);
    const tempSearchInput = searchInput;
    tempSearchInput.splice(index, 1);

    setPolicyListData([...tempPolicyListData]);
    setCheckedItems([...tempCheckedItems]);
    setFilterData([...tempFilteredData]);
    setSearchInput([...tempSearchInput]);
  };

  const handleFilterSearch = (searchText, index) => {
    const filterData = notificationList.filter(listItem => {
      if (searchText === '') {
        return listItem;
      }
      return listItem.includes(searchText);
    });
    const tempFiltedData = [...filteredData];
    tempFiltedData[index] = filterData;
    setFilterData(tempFiltedData);
    const tempSearchInput = [...searchInput];
    tempSearchInput[index] = searchText;
    setSearchInput(tempSearchInput);
  };
  const addNewPolicy = () => {
    policyListData.push(DEFAULT_POLICY_LIST[DEFAULT]);
    checkedItems.push([]);
    filteredData.push(notificationList);
    searchInput.push('');
    setPolicyListData([...policyListData]);
    setCheckedItems([...checkedItems]);
    setFilterData([...filteredData]);
    setSearchInput([...searchInput]);
  };

  return (
    <StyledModal
      open={open}
      // ref={modalRef}
      $maxWidth={1200}
      size="fullscreen"
      closeOnDimmerClick={false}
    >
      <StyledModalHeader>
        <Space gap={2}>
          <Text variant="h20" strong>
            {title}
          </Text>
          <Cross onClick={closeModal} />
        </Space>
      </StyledModalHeader>
      <StyledModalContent>
        <div>
          <ConfigTimeline currentIndex={step} actionsMode={actionsMode} />
        </div>
        <StyledContentWrapper>
          <Conditional if={step === 0}>
            <EndpointDetails
              actionsMode={actionsMode}
              testStatus={testStatus}
              loading={loading}
              // onSubmit={onSubmit}
              onTestClickHandler={onTestClickHandler}
              initialValues={endpointDetails}
              setEndpointDetails={setEndpointDetails}
              handleEndpointHandling={handleEndpointHandling}
              isEndpointChanging={isEndpointChanging}
            />
          </Conditional>
          <Conditional if={step === 1}>
            <PolicyList
              policyListData={policyListData}
              handlePolicyList={handlePolicyListChange}
              handlePolicyListDelete={handlePolicyListDelete}
              checkedItems={checkedItems}
              onSelectAllHandler={onSelectAllHandler}
              onClearAllHandler={onClearAllHandler}
              filteredData={filteredData}
              removeEvent={removeEvent}
              addEvent={addEvent}
              handleFilterSearch={handleFilterSearch}
              searchInput={searchInput}
            />
            <Button
              secondary
              onClick={addNewPolicy}
              disabled={policyListData.length >= 4}
              className="mt-2"
            >
              {' '}
              + Add Another Retry Policy
            </Button>
          </Conditional>
          <Conditional if={step === 2}>
            <Summary
              policyListData={policyListData}
              endpointDetails={endpointDetails}
              checkedItems={checkedItems}
            />
          </Conditional>
        </StyledContentWrapper>
      </StyledModalContent>
      <StyledModalActions>
        <Space justifyContent="flex-end">
          <Conditional if={step > 0}>
            <Button
              link
              type="button"
              className="link"
              onClick={handleBack}
              variant="link"
              danger
              // disabled={disabledField}
              data-event-name={`Form_AddTransactionWebhookModal_Step${step}_Button_Cancel`}
            >
              Back
            </Button>
          </Conditional>
          <Conditional
            if={
              (testStatus !== '' || actionsMode) &&
              endpointDetails.cfApiVersion !== '' &&
              !isEndpointChanging
            }
          >
            <Button
              type="button"
              loading={continueLoading || isLoading}
              onClick={handleSubmitClick}
              primary
              data-event-name={`Primary_Button_${submitButtonDisplay(
                actionsMode,
                step,
              )}`}
            >
              {submitButtonDisplay(actionsMode, step)}
            </Button>
          </Conditional>
          <Conditional
            if={
              !actionsMode &&
              (testStatus === '' ||
                endpointDetails.cfApiVersion === '' ||
                isEndpointChanging) &&
              step === 0
            }
          >
            <Popup
              content="Please test the url to continue"
              trigger={
                <span className="pointer">
                  <Button
                    // loading={disabledField || loading}
                    primary
                    disabled
                    data-event-name={`Primary_Button_${submitButtonDisplay(
                      actionsMode,
                      step,
                    )}`}
                  >
                    {submitButtonDisplay(actionsMode, step)}
                  </Button>
                </span>
              }
              position="top center"
            />
          </Conditional>
        </Space>
      </StyledModalActions>
    </StyledModal>
  );
}

export default memo(TransactionWebhookModal);
